import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const resourceBaseUrl = setting.resourceBaseUrl

export const commonApi = {
    // 获取文件链接
    getFileLink: (fileId) => {
      return axiosInstance.get(
        `${resourceBaseUrl}/file/${fileId}/link`
      )
    },
    // 其他 API 方法可以在这里添加
  } 